import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { loadConfig } from './services/config';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Runtime-config gate: the Clerk publishable key is delivered by the
// backend via GET /config (not baked into the bundle at build time), so
// the same built artifact can target different Clerk instances across
// environments. We must resolve /config BEFORE mounting <ClerkProvider>,
// which requires the key at construction time.
loadConfig()
  .then((config) => {
    const publishableKey = config.clerk_publishable_key;

    if (!publishableKey) {
      // Fail loudly rather than rendering a half-initialised auth shell —
      // a missing key is almost always a misconfigured backend env.
      root.render(
        <div className="app-loading">
          <p>
            Configuration error: Clerk publishable key is missing from
            /config. Check the backend CLERK_PUBLISHABLE_KEY env var.
          </p>
        </div>
      );
      return;
    }

    root.render(
      <React.StrictMode>
        <ClerkProvider publishableKey={publishableKey}>
          <App />
        </ClerkProvider>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error('Failed to load runtime config:', err);
    root.render(
      <div className="app-loading">
        <p>Failed to load application configuration. Please retry.</p>
      </div>
    );
  });
